<script setup lang="ts">
  import { onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'
  import type { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'
  import { useCommonStore } from '@/shared/store'
  import { useGoogleAnalytics, useLinkTarget } from '@/shared/composables'
  import CellQC from '@qicgroupdoha/qic-connect-ds/components/CellQC'
  import LinkQC from '@qicgroupdoha/qic-connect-ds/components/LinkQC'

  interface Props {
    place?: string
    dataTest?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    place: '',
    dataTest: 'privacy-policy-reminder',
  })

  const commonStore = useCommonStore()
  const policyUrl = ref('')

  const route = useRoute()
  const gaService = useGoogleAnalytics()
  const { getLinkTarget } = useLinkTarget()

  const onPolicyClick = () => {
    gaService.sendClickPrivacyPolicy(
      route.name as InboundFlowRoutes | OutboundFlowRoutes,
      props.place
    )
  }

  onMounted(async () => {
    try {
      policyUrl.value = await commonStore.getPrivacyPolicyUrl()
    } catch (error) {
      console.error(error)
    }
  })
</script>

<template>
  <CellQC class="ds-privacy-policy-reminder" padding-block="spacing-3">
    <template #title>
      {{ $t('contacts.privacy_policy.annotation') }}
      <LinkQC
        :href="policyUrl"
        :target="getLinkTarget()"
        :data-test="`${dataTest}-link`"
        @click="onPolicyClick"
      >
        {{ $t('contacts.privacy_policy.link') }}
      </LinkQC>
    </template>
  </CellQC>
</template>

<style lang="scss" scoped>
  .ds-privacy-policy-reminder {
    margin: 0 auto;

    :deep(.ds-base-link) {
      color: var(--colorTxtSrfTertiary);
    }
  }
</style>
